export default __webpack_public_path__ + "static/media/eduTwitter.5d8f75f0.svg";